import { z } from 'zod'

export const INVOICE_TYPE   = ['RENT', 'DEPOSIT', 'UTILITIES', 'PENALTY', 'ADDITIONAL', 'ONE_TIME'] as const
export const INVOICE_STATUS = ['PENDING', 'PAID', 'OVERDUE', 'CANCELLED', 'ADJUSTED', 'PARTIAL'] as const
export const PAYMENT_METHOD = ['KASSA', 'CASH', 'BANK_TRANSFER', 'CARD'] as const

const moneySchema   = z.string().regex(/^\d+(\.\d{1,2})?$/, 'Invalid amount').max(20)
const isoDateSchema = z.string().datetime({ offset: true })

export const invoiceItemSchema = z.object({
	id:          z.string().min(1).optional(),
	description: z.string().trim().min(1).max(500),
	amount:      moneySchema,
	// Required by the gateway (@IsNotEmpty), so not optional here — a missing
	// qty was rejected server-side with an error the user could not act on.
	qty:         z.string().regex(/^\d+(\.\d{1,4})?$/),
	unit:        z.string().max(20).optional(),
})

export const invoiceCreateSchema = z.object({
	rentalId:     z.string().min(1),
	type:         z.enum(INVOICE_TYPE),
	title:        z.string().trim().min(1).max(200),
	amount:       moneySchema,
	currency:     z.string().length(3),
	periodStart:  isoDateSchema,
	periodEnd:    isoDateSchema,
	dueDate:      isoDateSchema.optional(),
	items:        z.array(invoiceItemSchema).optional(),
}).refine((d) => new Date(d.periodEnd) >= new Date(d.periodStart), {
	message: 'periodEnd must be >= periodStart',
	path:    ['periodEnd'],
})

export const invoiceUpdateSchema = z.object({
	status:  z.enum(INVOICE_STATUS).optional(),
	title:   z.string().trim().min(1).max(200).optional(),
	amount:  moneySchema.optional(),
	dueDate: isoDateSchema.optional(),
	paidAt:  isoDateSchema.optional(),
})

export type InvoiceCreateInput = z.infer<typeof invoiceCreateSchema>
export type InvoiceUpdateInput = z.infer<typeof invoiceUpdateSchema>
